


// import React, { useState, useEffect } from "react";
// import {
//     Card, Table, Tag, Button, Modal, Space, message, Image, Descriptions,
//     Row, Col, Statistic, Tabs, Badge
// } from "antd";
// import {
//     VideoCameraOutlined,
//     CheckCircleOutlined,
//     CloseCircleOutlined,
//     EyeOutlined,
//     DeleteOutlined,
//     ClockCircleOutlined,
//     CalendarOutlined,
//     DollarOutlined,
//     LinkOutlined,
//     FireOutlined,
//     StopOutlined,
//     UserOutlined,
//     MailOutlined,
// } from "@ant-design/icons";
// import dayjs from "dayjs";
// import liveTrainingService from "../../../services/liveTraining.service";

// const { TabPane } = Tabs;

// const LiveTrainingsAdmin = () => {
//     const [allTrainings, setAllTrainings] = useState([]);
//     const [pendingTrainings, setPendingTrainings] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [selectedTraining, setSelectedTraining] = useState(null);
//     const [activeTab, setActiveTab] = useState("1");
//     const [detailsVisible, setDetailsVisible] = useState(false);

//     // ⭐ NOUVEAU : Charger les données ENRICHIES (avec créateur)
//     const loadAllTrainings = async () => {
//         setLoading(true);
//         try {
//             const data = await liveTrainingService.getAllForAdminEnriched();
//             setAllTrainings(data);
//         } catch (error) {
//             message.error("Erreur lors du chargement des formations live");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const loadPendingTrainings = async () => {
//         setLoading(true);
//         try {
//             const data = await liveTrainingService.getPendingEnriched();
//             setPendingTrainings(data);
//         } catch (error) {
//             message.error("Erreur lors du chargement des formations en attente");
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         loadAllTrainings();
//         loadPendingTrainings();
//     }, []);

//     const handleApprove = async (id, title) => {
//         Modal.confirm({
//             title: `Approuver la formation : ${title} ?`,
//             content: "Cette formation sera visible sur la page publique pour tous les étudiants.",
//             icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
//             okText: "Approuver",
//             okType: "primary",
//             cancelText: "Annuler",
//             onOk: async () => {
//                 try {
//                     await liveTrainingService.approve(id);
//                     message.success("Formation live approuvée avec succès !");
//                     loadAllTrainings();
//                     loadPendingTrainings();
//                 } catch (error) {
//                     message.error("Erreur lors de l'approbation");
//                 }
//             }
//         });
//     };

//     const handleReject = async (id, title) => {
//         Modal.confirm({
//             title: `Rejeter la formation : ${title} ?`,
//             content: "Cette formation ne sera pas visible aux étudiants.",
//             icon: <CloseCircleOutlined style={{ color: '#ff4d4f' }} />,
//             okText: "Rejeter",
//             okType: "danger",
//             cancelText: "Annuler",
//             onOk: async () => {
//                 try {
//                     await liveTrainingService.reject(id);
//                     message.success("Formation live rejetée");
//                     loadAllTrainings();
//                     loadPendingTrainings();
//                 } catch (error) {
//                     message.error("Erreur lors du rejet");
//                 }
//             }
//         });
//     };

//     const handlePermanentlyDelete = async (id, title) => {
//         Modal.confirm({
//             title: `Supprimer définitivement : ${title} ?`,
//             content: (
//                 <div>
//                     <p style={{ color: '#ff4d4f', fontWeight: 'bold' }}>
//                         ⚠️ Cette action est irréversible !
//                     </p>
//                     <p>La formation doit d'abord être supprimée (corbeille) par le modérateur.</p>
//                 </div>
//             ),
//             icon: <DeleteOutlined style={{ color: '#ff4d4f' }} />,
//             okText: "Supprimer définitivement",
//             okType: "danger",
//             cancelText: "Annuler",
//             onOk: async () => {
//                 try {
//                     await liveTrainingService.permanentlyDelete(id);
//                     message.success("Formation supprimée définitivement");
//                     loadAllTrainings();
//                 } catch (error) {
//                     message.error("Cette formation doit être dans la corbeille avant suppression définitive");
//                 }
//             }
//         });
//     };

//     const handleViewDetails = (training) => {
//         setSelectedTraining(training);
//         setDetailsVisible(true);
//     };

//     const formatLiveDate = (date) => {
//         if (!date) return "—";
//         return dayjs(date).format("DD/MM/YYYY HH:mm");
//     };

//     const getStatusTag = (training) => {
//         if (training.deletedByModerator) {
//             return <Tag color="red" icon={<DeleteOutlined />}>Supprimée</Tag>;
//         }
//         if (!training.approved) {
//             return <Tag color="orange" icon={<ClockCircleOutlined />}>En attente</Tag>;
//         }
//         return <Tag color="green" icon={<CheckCircleOutlined />}>Approuvée</Tag>;
//     };

//     // Colonnes du tableau
//     const columns = [
//         {
//             title: "ID",
//             dataIndex: "id",
//             key: "id",
//             width: 60,
//             align: 'center',
//             render: (id) => (
//                 <Tag color="red" style={{ fontWeight: 'bold' }}>
//                     #{id}
//                 </Tag>
//             )
//         },
//         {
//             title: "Image",
//             dataIndex: "image",
//             key: "image",
//             width: 100,
//             render: (image) =>
//                 image ? (
//                     <Image
//                         src={image}
//                         alt="cover"
//                         width={70}
//                         height={50}
//                         style={{ borderRadius: 6, objectFit: 'cover' }}
//                         preview={false}
//                     />
//                 ) : (
//                     <div style={{
//                         width: 70, height: 50,
//                         background: 'linear-gradient(135deg, #ee5a6f 0%, #ff6b6b 100%)',
//                         borderRadius: 6,
//                         display: 'flex', alignItems: 'center', justifyContent: 'center',
//                         color: 'white', fontSize: 20
//                     }}>
//                         <VideoCameraOutlined />
//                     </div>
//                 )
//         },
//         {
//             title: "Formation",
//             dataIndex: "title",
//             key: "title",
//             ellipsis: true,
//             render: (title, record) => (
//                 <div>
//                     <div style={{ fontWeight: 'bold', marginBottom: 4 }}>{title}</div>
//                     <div style={{ fontSize: '12px', color: '#999' }}>
//                         {record.duration && `⏱️ ${record.duration} • `}
//                         {record.categoryName && `📂 ${record.categoryName}`}
//                     </div>
//                 </div>
//             )
//         },
//         // ⭐ NOUVELLE COLONNE CRÉATEUR
//         {
//             title: "Créateur",
//             key: "creator",
//             width: 220,
//             render: (_, record) => (
//                 <div>
//                     <div style={{ fontWeight: 'bold', color: '#722ed1', display: 'flex', alignItems: 'center', gap: 6 }}>
//                         <UserOutlined /> {record.creatorUsername || `User #${record.createdBy}`}
//                     </div>
//                     {record.creatorEmail && record.creatorEmail !== '—' && (
//                         <div style={{ fontSize: '11px', color: '#999', marginTop: 2 }}>
//                             <MailOutlined style={{ marginRight: 4 }} />
//                             {record.creatorEmail}
//                         </div>
//                     )}
//                 </div>
//             )
//         },
//         {
//             title: "Date Live",
//             dataIndex: "liveDate",
//             key: "liveDate",
//             width: 160,
//             render: (date) => (
//                 <Tag icon={<CalendarOutlined />} color="blue">
//                     {formatLiveDate(date)}
//                 </Tag>
//             )
//         },
//         {
//             title: "Prix",
//             dataIndex: "price",
//             key: "price",
//             width: 100,
//             align: 'center',
//             render: (price) => (
//                 <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#52c41a' }}>
//                     {price?.toFixed(2)} €
//                 </span>
//             )
//         },
//         {
//             title: "Statut",
//             key: "status",
//             width: 130,
//             align: 'center',
//             render: (_, record) => getStatusTag(record)
//         },
//         {
//             title: "Actions",
//             key: "actions",
//             width: 380,
//             fixed: 'right',
//             render: (_, record) => (
//                 <Space wrap size={[4, 8]}>
//                     <Button
//                         type="default"
//                         size="small"
//                         icon={<EyeOutlined />}
//                         onClick={() => handleViewDetails(record)}
//                         style={{ borderColor: '#1890ff', color: '#1890ff' }}
//                     >
//                         Détails
//                     </Button>

//                     {!record.deletedByModerator && !record.approved && (
//                         <Button
//                             type="primary"
//                             size="small"
//                             icon={<CheckCircleOutlined />}
//                             onClick={() => handleApprove(record.id, record.title)}
//                             style={{ background: '#52c41a', borderColor: '#52c41a' }}
//                         >
//                             Approuver
//                         </Button>
//                     )}

//                     {!record.deletedByModerator && record.approved && (
//                         <Button
//                             danger
//                             size="small"
//                             icon={<StopOutlined />}
//                             onClick={() => handleReject(record.id, record.title)}
//                         >
//                             Rejeter
//                         </Button>
//                     )}

//                     {record.deletedByModerator && (
//                         <Button
//                             danger
//                             size="small"
//                             icon={<DeleteOutlined />}
//                             onClick={() => handlePermanentlyDelete(record.id, record.title)}
//                         >
//                             Supprimer définitivement
//                         </Button>
//                     )}

//                     <Button
//                         type="default"
//                         size="small"
//                         icon={<EyeOutlined />}
//                         onClick={() => window.open(`/live-training/${record.id}`, '_blank')}
//                         style={{ borderColor: '#ee5a6f', color: '#ee5a6f' }}
//                         title="Voir page étudiant"
//                     >
//                         Page étudiant
//                     </Button>
//                 </Space>
//             )
//         }
//     ];

//     // Statistiques
//     const stats = {
//         total: allTrainings.length,
//         pending: allTrainings.filter(t => !t.approved && !t.deletedByModerator).length,
//         approved: allTrainings.filter(t => t.approved && !t.deletedByModerator).length,
//         upcoming: allTrainings.filter(
//             t => t.approved && !t.deletedByModerator && t.liveDate && dayjs(t.liveDate).isAfter(dayjs())
//         ).length,
//     };

//     return (
//         <div>
//             {/* STATISTIQUES */}
//             <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
//                 <Col xs={24} sm={12} lg={6}>
//                     <Card bordered={false} style={{ borderLeft: '4px solid #ee5a6f', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//                         <Statistic
//                             title="Total Formations Live"
//                             value={stats.total}
//                             prefix={<VideoCameraOutlined style={{ color: '#ee5a6f' }} />}
//                             valueStyle={{ color: '#ee5a6f' }}
//                         />
//                     </Card>
//                 </Col>
//                 <Col xs={24} sm={12} lg={6}>
//                     <Card bordered={false} style={{ borderLeft: '4px solid #faad14', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//                         <Statistic
//                             title="En attente"
//                             value={stats.pending}
//                             prefix={<ClockCircleOutlined style={{ color: '#faad14' }} />}
//                             valueStyle={{ color: '#faad14' }}
//                         />
//                     </Card>
//                 </Col>
//                 <Col xs={24} sm={12} lg={6}>
//                     <Card bordered={false} style={{ borderLeft: '4px solid #52c41a', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//                         <Statistic
//                             title="Approuvées"
//                             value={stats.approved}
//                             prefix={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
//                             valueStyle={{ color: '#52c41a' }}
//                         />
//                     </Card>
//                 </Col>
//                 <Col xs={24} sm={12} lg={6}>
//                     <Card bordered={false} style={{ borderLeft: '4px solid #1890ff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//                         <Statistic
//                             title="À venir"
//                             value={stats.upcoming}
//                             prefix={<FireOutlined style={{ color: '#1890ff' }} />}
//                             valueStyle={{ color: '#1890ff' }}
//                         />
//                     </Card>
//                 </Col>
//             </Row>

//             {/* TABS */}
//             <Tabs activeKey={activeTab} onChange={setActiveTab}>
//                 <TabPane
//                     tab={
//                         <Badge count={stats.pending} color="#faad14" offset={[10, 0]}>
//                             <span style={{ paddingRight: 16 }}>
//                                 <ClockCircleOutlined style={{ marginRight: 8 }} />
//                                 En attente d'approbation
//                             </span>
//                         </Badge>
//                     }
//                     key="1"
//                 >
//                     <Card
//                         bordered={false}
//                         style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
//                         title={<><ClockCircleOutlined style={{ marginRight: 8, color: '#faad14' }} />Formations en attente d'approbation</>}
//                     >
//                         <Table
//                             columns={columns}
//                             dataSource={pendingTrainings}
//                             rowKey="id"
//                             loading={loading}
//                             scroll={{ x: 1500 }}
//                             pagination={{
//                                 pageSize: 10,
//                                 showSizeChanger: true,
//                                 showTotal: (total) => `${total} formation(s) en attente`,
//                             }}
//                             locale={{ emptyText: "🎉 Aucune formation en attente !" }}
//                         />
//                     </Card>
//                 </TabPane>

//                 <TabPane
//                     tab={
//                         <Badge count={stats.total} color="#1890ff" offset={[10, 0]}>
//                             <span style={{ paddingRight: 16 }}>
//                                 <VideoCameraOutlined style={{ marginRight: 8 }} />
//                                 Toutes les formations
//                             </span>
//                         </Badge>
//                     }
//                     key="2"
//                 >
//                     <Card
//                         bordered={false}
//                         style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
//                         title={
//                             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                 <div><VideoCameraOutlined style={{ marginRight: 8, color: '#ee5a6f' }} />Toutes les formations Live</div>
//                                 <div style={{ display: 'flex', gap: 8 }}>
//                                     <Tag color="success">{stats.approved} Approuvées</Tag>
//                                     <Tag color="warning">{stats.pending} En attente</Tag>
//                                     <Tag color="blue">{stats.total} Total</Tag>
//                                 </div>
//                             </div>
//                         }
//                     >
//                         <Table
//                             columns={columns}
//                             dataSource={allTrainings}
//                             rowKey="id"
//                             loading={loading}
//                             scroll={{ x: 1500 }}
//                             pagination={{
//                                 pageSize: 10,
//                                 showSizeChanger: true,
//                                 showTotal: (total) => `${total} formation(s)`,
//                             }}
//                         />
//                     </Card>
//                 </TabPane>
//             </Tabs>

//             {/* MODAL DÉTAILS */}
//             <Modal
//                 title={
//                     <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//                         <VideoCameraOutlined style={{ color: '#ee5a6f' }} />
//                         Détails : {selectedTraining?.title}
//                     </div>
//                 }
//                 open={detailsVisible}
//                 onCancel={() => setDetailsVisible(false)}
//                 footer={
//                     selectedTraining && !selectedTraining.deletedByModerator && !selectedTraining.approved ? (
//                         <Space>
//                             <Button onClick={() => setDetailsVisible(false)}>Fermer</Button>
//                             <Button
//                                 danger
//                                 icon={<CloseCircleOutlined />}
//                                 onClick={() => {
//                                     handleReject(selectedTraining.id, selectedTraining.title);
//                                     setDetailsVisible(false);
//                                 }}
//                             >
//                                 Rejeter
//                             </Button>
//                             <Button
//                                 type="primary"
//                                 icon={<CheckCircleOutlined />}
//                                 style={{ background: '#52c41a', borderColor: '#52c41a' }}
//                                 onClick={() => {
//                                     handleApprove(selectedTraining.id, selectedTraining.title);
//                                     setDetailsVisible(false);
//                                 }}
//                             >
//                                 Approuver
//                             </Button>
//                         </Space>
//                     ) : (
//                         <Button onClick={() => setDetailsVisible(false)}>Fermer</Button>
//                     )
//                 }
//                 width={800}
//             >
//                 {selectedTraining && (
//                     <Row gutter={[24, 16]}>
//                         <Col xs={24} md={10}>
//                             {selectedTraining.image ? (
//                                 <Image src={selectedTraining.image} alt={selectedTraining.title} style={{ width: "100%", borderRadius: 8 }} />
//                             ) : (
//                                 <div style={{
//                                     height: 200,
//                                     background: 'linear-gradient(135deg, #ee5a6f 0%, #ff6b6b 100%)',
//                                     borderRadius: 8,
//                                     display: 'flex', alignItems: 'center', justifyContent: 'center',
//                                     color: 'white', fontSize: 60
//                                 }}>
//                                     <VideoCameraOutlined />
//                                 </div>
//                             )}
//                         </Col>
//                         <Col xs={24} md={14}>
//                             <Descriptions bordered column={1} size="small">
//                                 <Descriptions.Item label="Statut">
//                                     {getStatusTag(selectedTraining)}
//                                 </Descriptions.Item>

//                                 {/* ⭐ NOUVEAU : Infos créateur */}
//                                 <Descriptions.Item label={<><UserOutlined /> Créé par</>}>
//                                     <strong style={{ color: '#722ed1' }}>
//                                         {selectedTraining.creatorUsername || `User #${selectedTraining.createdBy}`}
//                                     </strong>
//                                 </Descriptions.Item>
//                                 <Descriptions.Item label={<><MailOutlined /> Email créateur</>}>
//                                     {selectedTraining.creatorEmail || "—"}
//                                 </Descriptions.Item>

//                                 <Descriptions.Item label={<><CalendarOutlined /> Date du live</>}>
//                                     {formatLiveDate(selectedTraining.liveDate)}
//                                 </Descriptions.Item>
//                                 <Descriptions.Item label={<><ClockCircleOutlined /> Durée</>}>
//                                     {selectedTraining.duration || "—"}
//                                 </Descriptions.Item>
//                                 <Descriptions.Item label={<><DollarOutlined /> Prix</>}>
//                                     <span style={{ fontSize: 18, fontWeight: 'bold', color: '#52c41a' }}>
//                                         {selectedTraining.price?.toFixed(2)} €
//                                     </span>
//                                 </Descriptions.Item>
//                                 <Descriptions.Item label="Catégorie">
//                                     {selectedTraining.categoryName || "—"}
//                                 </Descriptions.Item>
//                                 <Descriptions.Item label="Sous-catégorie">
//                                     {selectedTraining.subcategoryName || "—"}
//                                 </Descriptions.Item>
//                                 <Descriptions.Item label={<><LinkOutlined /> Lien meeting</>}>
//                                     {selectedTraining.meetingLink ? (
//                                         <a href={selectedTraining.meetingLink} target="_blank" rel="noopener noreferrer">
//                                             {selectedTraining.meetingLink}
//                                         </a>
//                                     ) : "—"}
//                                 </Descriptions.Item>
//                             </Descriptions>
//                         </Col>

//                         <Col span={24}>
//                             <Descriptions bordered column={1} size="small">
//                                 <Descriptions.Item label="Description courte">
//                                     {selectedTraining.short_desc || "—"}
//                                 </Descriptions.Item>

//                                 {selectedTraining.overview && (
//                                     <Descriptions.Item label="Aperçu">
//                                         <div dangerouslySetInnerHTML={{ __html: selectedTraining.overview }} />
//                                     </Descriptions.Item>
//                                 )}

//                                 {selectedTraining.what_you_will_learn && (
//                                     <Descriptions.Item label="Ce que vous allez apprendre">
//                                         <div dangerouslySetInnerHTML={{ __html: selectedTraining.what_you_will_learn }} />
//                                     </Descriptions.Item>
//                                 )}

//                                 {selectedTraining.requirements && (
//                                     <Descriptions.Item label="Prérequis">
//                                         <div dangerouslySetInnerHTML={{ __html: selectedTraining.requirements }} />
//                                     </Descriptions.Item>
//                                 )}

//                                 {selectedTraining.who_is_this_course_for && (
//                                     <Descriptions.Item label="Public cible">
//                                         <div dangerouslySetInnerHTML={{ __html: selectedTraining.who_is_this_course_for }} />
//                                     </Descriptions.Item>
//                                 )}
//                             </Descriptions>
//                         </Col>
//                     </Row>
//                 )}
//             </Modal>
//         </div>
//     );
// };

// export default LiveTrainingsAdmin;


import React, { useState, useEffect } from "react";
import {
    Card, Table, Tag, Button, Modal, Space, message, Image, Descriptions,
    Row, Col, Statistic, Tabs, Badge
} from "antd";
import {
    VideoCameraOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    EyeOutlined,
    DeleteOutlined,
    ClockCircleOutlined,
    DollarOutlined,
    StopOutlined,
    UserOutlined,
    MailOutlined,
    FireOutlined,
} from "@ant-design/icons";
import liveTrainingService from "../../../services/liveTraining.service";

const { TabPane } = Tabs;

const LiveTrainingsAdmin = () => {
    const [allTrainings, setAllTrainings] = useState([]);
    const [pendingTrainings, setPendingTrainings] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedTraining, setSelectedTraining] = useState(null);
    const [activeTab, setActiveTab] = useState("1");
    const [detailsVisible, setDetailsVisible] = useState(false);

    // Charger les données enrichies
    const loadAllTrainings = async () => {
        setLoading(true);
        try {
            const data = await liveTrainingService.getAllForAdminEnriched();
            setAllTrainings(data);
        } catch (error) {
            message.error("Erreur lors du chargement des formations live");
        } finally {
            setLoading(false);
        }
    };

    const loadPendingTrainings = async () => {
        setLoading(true);
        try {
            const data = await liveTrainingService.getPendingEnriched();
            setPendingTrainings(data);
        } catch (error) {
            message.error("Erreur lors du chargement des formations en attente");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadAllTrainings();
        loadPendingTrainings();
    }, []);

    const handleApprove = async (id, title) => {
        Modal.confirm({
            title: `Approuver la formation : ${title} ?`,
            content: "Cette formation sera visible sur la page publique pour tous les étudiants.",
            icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
            okText: "Approuver",
            okType: "primary",
            cancelText: "Annuler",
            onOk: async () => {
                try {
                    await liveTrainingService.approve(id);
                    message.success("Formation live approuvée avec succès !");
                    loadAllTrainings();
                    loadPendingTrainings();
                } catch (error) {
                    message.error("Erreur lors de l'approbation");
                }
            }
        });
    };

    const handleReject = async (id, title) => {
        Modal.confirm({
            title: `Rejeter la formation : ${title} ?`,
            content: "Cette formation ne sera pas visible aux étudiants.",
            icon: <CloseCircleOutlined style={{ color: '#ff4d4f' }} />,
            okText: "Rejeter",
            okType: "danger",
            cancelText: "Annuler",
            onOk: async () => {
                try {
                    await liveTrainingService.reject(id);
                    message.success("Formation live rejetée");
                    loadAllTrainings();
                    loadPendingTrainings();
                } catch (error) {
                    message.error("Erreur lors du rejet");
                }
            }
        });
    };

    const handlePermanentlyDelete = async (id, title) => {
        Modal.confirm({
            title: `Supprimer définitivement : ${title} ?`,
            content: (
                <div>
                    <p style={{ color: '#ff4d4f', fontWeight: 'bold' }}>
                        ⚠️ Cette action est irréversible !
                    </p>
                    <p>La formation doit d'abord être supprimée (corbeille) par le modérateur.</p>
                </div>
            ),
            icon: <DeleteOutlined style={{ color: '#ff4d4f' }} />,
            okText: "Supprimer définitivement",
            okType: "danger",
            cancelText: "Annuler",
            onOk: async () => {
                try {
                    await liveTrainingService.permanentlyDelete(id);
                    message.success("Formation supprimée définitivement");
                    loadAllTrainings();
                } catch (error) {
                    message.error("Cette formation doit être dans la corbeille avant suppression définitive");
                }
            }
        });
    };

    const handleViewDetails = (training) => {
        setSelectedTraining(training);
        setDetailsVisible(true);
    };

    const getStatusTag = (training) => {
        if (training.deletedByModerator) {
            return <Tag color="red" icon={<DeleteOutlined />}>Supprimée</Tag>;
        }
        if (!training.approved) {
            return <Tag color="orange" icon={<ClockCircleOutlined />}>En attente</Tag>;
        }
        return <Tag color="green" icon={<CheckCircleOutlined />}>Approuvée</Tag>;
    };

    // Colonnes du tableau
    const columns = [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 60,
            align: 'center',
            render: (id) => (
                <Tag color="red" style={{ fontWeight: 'bold' }}>
                    #{id}
                </Tag>
            )
        },
        {
            title: "Image",
            dataIndex: "image",
            key: "image",
            width: 100,
            render: (image) =>
                image ? (
                    <Image
                        src={image}
                        alt="cover"
                        width={70}
                        height={50}
                        style={{ borderRadius: 6, objectFit: 'cover' }}
                        preview={false}
                    />
                ) : (
                    <div style={{
                        width: 70, height: 50,
                        background: 'linear-gradient(135deg, #ee5a6f 0%, #ff6b6b 100%)',
                        borderRadius: 6,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: 'white', fontSize: 20
                    }}>
                        <VideoCameraOutlined />
                    </div>
                )
        },
        {
            title: "Formation",
            dataIndex: "title",
            key: "title",
            ellipsis: true,
            render: (title, record) => (
                <div>
                    <div style={{ fontWeight: 'bold', marginBottom: 4 }}>{title}</div>
                    <div style={{ fontSize: '12px', color: '#999' }}>
                        {record.duration && `⏱️ ${record.duration} • `}
                        {record.categoryName && `📂 ${record.categoryName}`}
                    </div>
                </div>
            )
        },
        {
            title: "Créateur",
            key: "creator",
            width: 220,
            render: (_, record) => (
                <div>
                    <div style={{ fontWeight: 'bold', color: '#722ed1', display: 'flex', alignItems: 'center', gap: 6 }}>
                        <UserOutlined /> {record.creatorUsername || `User #${record.createdBy}`}
                    </div>
                    {record.creatorEmail && record.creatorEmail !== '—' && (
                        <div style={{ fontSize: '11px', color: '#999', marginTop: 2 }}>
                            <MailOutlined style={{ marginRight: 4 }} />
                            {record.creatorEmail}
                        </div>
                    )}
                </div>
            )
        },
        {
            title: "Prix",
            dataIndex: "price",
            key: "price",
            width: 100,
            align: 'center',
            render: (price) => (
                <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#52c41a' }}>
                    {price?.toFixed(2)} €
                </span>
            )
        },
        {
            title: "Statut",
            key: "status",
            width: 130,
            align: 'center',
            render: (_, record) => getStatusTag(record)
        },
        {
            title: "Actions",
            key: "actions",
            width: 380,
            fixed: 'right',
            render: (_, record) => (
                <Space wrap size={[4, 8]}>
                    <Button
                        type="default"
                        size="small"
                        icon={<EyeOutlined />}
                        onClick={() => handleViewDetails(record)}
                        style={{ borderColor: '#1890ff', color: '#1890ff' }}
                    >
                        Détails
                    </Button>

                    {!record.deletedByModerator && !record.approved && (
                        <Button
                            type="primary"
                            size="small"
                            icon={<CheckCircleOutlined />}
                            onClick={() => handleApprove(record.id, record.title)}
                            style={{ background: '#52c41a', borderColor: '#52c41a' }}
                        >
                            Approuver
                        </Button>
                    )}

                    {!record.deletedByModerator && record.approved && (
                        <Button
                            danger
                            size="small"
                            icon={<StopOutlined />}
                            onClick={() => handleReject(record.id, record.title)}
                        >
                            Rejeter
                        </Button>
                    )}

                    {record.deletedByModerator && (
                        <Button
                            danger
                            size="small"
                            icon={<DeleteOutlined />}
                            onClick={() => handlePermanentlyDelete(record.id, record.title)}
                        >
                            Supprimer définitivement
                        </Button>
                    )}

                    <Button
                        type="default"
                        size="small"
                        icon={<EyeOutlined />}
                        onClick={() => window.open(`/live-training/${record.id}`, '_blank')}
                        style={{ borderColor: '#ee5a6f', color: '#ee5a6f' }}
                        title="Voir page étudiant"
                    >
                        Page étudiant
                    </Button>
                </Space>
            )
        }
    ];

    // Statistiques
    const stats = {
        total: allTrainings.length,
        pending: allTrainings.filter(t => !t.approved && !t.deletedByModerator).length,
        approved: allTrainings.filter(t => t.approved && !t.deletedByModerator).length,
    };

    return (
        <div>
            {/* STATISTIQUES */}
            <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                <Col xs={24} sm={12} lg={8}>
                    <Card bordered={false} style={{ borderLeft: '4px solid #ee5a6f', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                        <Statistic
                            title="Total Formations Live"
                            value={stats.total}
                            prefix={<VideoCameraOutlined style={{ color: '#ee5a6f' }} />}
                            valueStyle={{ color: '#ee5a6f' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={8}>
                    <Card bordered={false} style={{ borderLeft: '4px solid #faad14', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                        <Statistic
                            title="En attente"
                            value={stats.pending}
                            prefix={<ClockCircleOutlined style={{ color: '#faad14' }} />}
                            valueStyle={{ color: '#faad14' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={8}>
                    <Card bordered={false} style={{ borderLeft: '4px solid #52c41a', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                        <Statistic
                            title="Approuvées"
                            value={stats.approved}
                            prefix={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
                            valueStyle={{ color: '#52c41a' }}
                        />
                    </Card>
                </Col>
            </Row>

            {/* TABS */}
            <Tabs activeKey={activeTab} onChange={setActiveTab}>
                <TabPane
                    tab={
                        <Badge count={stats.pending} color="#faad14" offset={[10, 0]}>
                            <span style={{ paddingRight: 16 }}>
                                <ClockCircleOutlined style={{ marginRight: 8 }} />
                                En attente d'approbation
                            </span>
                        </Badge>
                    }
                    key="1"
                >
                    <Card
                        bordered={false}
                        style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                        title={<><ClockCircleOutlined style={{ marginRight: 8, color: '#faad14' }} />Formations en attente d'approbation</>}
                    >
                        <Table
                            columns={columns}
                            dataSource={pendingTrainings}
                            rowKey="id"
                            loading={loading}
                            scroll={{ x: 1500 }}
                            pagination={{
                                pageSize: 10,
                                showSizeChanger: true,
                                showTotal: (total) => `${total} formation(s) en attente`,
                            }}
                            locale={{ emptyText: "🎉 Aucune formation en attente !" }}
                        />
                    </Card>
                </TabPane>

                <TabPane
                    tab={
                        <Badge count={stats.total} color="#1890ff" offset={[10, 0]}>
                            <span style={{ paddingRight: 16 }}>
                                <VideoCameraOutlined style={{ marginRight: 8 }} />
                                Toutes les formations
                            </span>
                        </Badge>
                    }
                    key="2"
                >
                    <Card
                        bordered={false}
                        style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                        title={
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div><VideoCameraOutlined style={{ marginRight: 8, color: '#ee5a6f' }} />Toutes les formations Live</div>
                                <div style={{ display: 'flex', gap: 8 }}>
                                    <Tag color="success">{stats.approved} Approuvées</Tag>
                                    <Tag color="warning">{stats.pending} En attente</Tag>
                                    <Tag color="blue">{stats.total} Total</Tag>
                                </div>
                            </div>
                        }
                    >
                        <Table
                            columns={columns}
                            dataSource={allTrainings}
                            rowKey="id"
                            loading={loading}
                            scroll={{ x: 1500 }}
                            pagination={{
                                pageSize: 10,
                                showSizeChanger: true,
                                showTotal: (total) => `${total} formation(s)`,
                            }}
                        />
                    </Card>
                </TabPane>
            </Tabs>

            {/* MODAL DÉTAILS */}
            <Modal
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <VideoCameraOutlined style={{ color: '#ee5a6f' }} />
                        Détails : {selectedTraining?.title}
                    </div>
                }
                open={detailsVisible}
                onCancel={() => setDetailsVisible(false)}
                footer={
                    selectedTraining && !selectedTraining.deletedByModerator && !selectedTraining.approved ? (
                        <Space>
                            <Button onClick={() => setDetailsVisible(false)}>Fermer</Button>
                            <Button
                                danger
                                icon={<CloseCircleOutlined />}
                                onClick={() => {
                                    handleReject(selectedTraining.id, selectedTraining.title);
                                    setDetailsVisible(false);
                                }}
                            >
                                Rejeter
                            </Button>
                            <Button
                                type="primary"
                                icon={<CheckCircleOutlined />}
                                style={{ background: '#52c41a', borderColor: '#52c41a' }}
                                onClick={() => {
                                    handleApprove(selectedTraining.id, selectedTraining.title);
                                    setDetailsVisible(false);
                                }}
                            >
                                Approuver
                            </Button>
                        </Space>
                    ) : (
                        <Button onClick={() => setDetailsVisible(false)}>Fermer</Button>
                    )
                }
                width={800}
            >
                {selectedTraining && (
                    <Row gutter={[24, 16]}>
                        <Col xs={24} md={10}>
                            {selectedTraining.image ? (
                                <Image src={selectedTraining.image} alt={selectedTraining.title} style={{ width: "100%", borderRadius: 8 }} />
                            ) : (
                                <div style={{
                                    height: 200,
                                    background: 'linear-gradient(135deg, #ee5a6f 0%, #ff6b6b 100%)',
                                    borderRadius: 8,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    color: 'white', fontSize: 60
                                }}>
                                    <VideoCameraOutlined />
                                </div>
                            )}
                        </Col>
                        <Col xs={24} md={14}>
                            <Descriptions bordered column={1} size="small">
                                <Descriptions.Item label="Statut">
                                    {getStatusTag(selectedTraining)}
                                </Descriptions.Item>

                                <Descriptions.Item label={<><UserOutlined /> Créé par</>}>
                                    <strong style={{ color: '#722ed1' }}>
                                        {selectedTraining.creatorUsername || `User #${selectedTraining.createdBy}`}
                                    </strong>
                                </Descriptions.Item>
                                <Descriptions.Item label={<><MailOutlined /> Email créateur</>}>
                                    {selectedTraining.creatorEmail || "—"}
                                </Descriptions.Item>

                                <Descriptions.Item label={<><ClockCircleOutlined /> Durée</>}>
                                    {selectedTraining.duration || "—"}
                                </Descriptions.Item>
                                <Descriptions.Item label={<><DollarOutlined /> Prix</>}>
                                    <span style={{ fontSize: 18, fontWeight: 'bold', color: '#52c41a' }}>
                                        {selectedTraining.price?.toFixed(2)} €
                                    </span>
                                </Descriptions.Item>
                                <Descriptions.Item label="Catégorie">
                                    {selectedTraining.categoryName || "—"}
                                </Descriptions.Item>
                                <Descriptions.Item label="Sous-catégorie">
                                    {selectedTraining.subcategoryName || "—"}
                                </Descriptions.Item>
                            </Descriptions>
                        </Col>

                        <Col span={24}>
                            <Descriptions bordered column={1} size="small">
                                <Descriptions.Item label="Description courte">
                                    {selectedTraining.short_desc || "—"}
                                </Descriptions.Item>

                                {selectedTraining.overview && (
                                    <Descriptions.Item label="Aperçu">
                                        <div dangerouslySetInnerHTML={{ __html: selectedTraining.overview }} />
                                    </Descriptions.Item>
                                )}

                                {selectedTraining.what_you_will_learn && (
                                    <Descriptions.Item label="Ce que vous allez apprendre">
                                        <div dangerouslySetInnerHTML={{ __html: selectedTraining.what_you_will_learn }} />
                                    </Descriptions.Item>
                                )}

                                {selectedTraining.requirements && (
                                    <Descriptions.Item label="Prérequis">
                                        <div dangerouslySetInnerHTML={{ __html: selectedTraining.requirements }} />
                                    </Descriptions.Item>
                                )}

                                {selectedTraining.who_is_this_course_for && (
                                    <Descriptions.Item label="Public cible">
                                        <div dangerouslySetInnerHTML={{ __html: selectedTraining.who_is_this_course_for }} />
                                    </Descriptions.Item>
                                )}
                            </Descriptions>
                        </Col>
                    </Row>
                )}
            </Modal>
        </div>
    );
};

export default LiveTrainingsAdmin;